import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Landing } from '@/domain/share/Landing';
import { getStagePrefix } from '@/utils/api';

export default function MembershipEssential() {
  const [ query ] = useSearchParams();
  const language = query.get('language') ?? 'ko';

  useEffect(() => {
    const link = `https://theswing.onelink.me/bDAE?af_xp=text&pid=SMS&is_retargeting=true&af_reengagement_window=1h&deep_link_value=theswing%3A%2F%2Fwv%3Furl%3Dhttps%253A%252F%252F${getStagePrefix()}app.static.swingmobility.dev%252Fgo%252Fmembership%252Fstore%252F1%253Flanguage%253D${language}&af_dp=theswing%3A%2F%2Fwv%3Furl%3Dhttps%253A%252F%252F${getStagePrefix()}app.static.swingmobility.dev%252Fgo%252Fmembership%252Fstore%252F1%253Flanguage%253D${language}`;
    setTimeout(() => window.location.href = link, 400);
  }, []);

  return <Landing />;
}